class BoxDDayHP {
  render() {
    this.handlers();
  }

  handlers() {
    if (document.querySelector('div#box_tecnologia_dday_HP') !== null) {
      this.init();
    }
  }

  init() {
    let monthNames = [
      null,
      'gennaio',
      'febbraio',
      'marzo',
      'aprile',
      'maggio',
      'giugno',
      'luglio',
      'agosto',
      'settembre',
      'ottobre',
      'novembre',
      'dicembre'
    ];
    let url = '//xml2.corriereobjects.it/tools/json/dday_news.json';

    this.fetchJson(url, ddayjson => {
      let ddayFeedElements = Array.from(document.querySelectorAll('.news-dday-feed'));
      let i = 0;
      ddayFeedElements.forEach(inDDex => {
        let currentEntry = ddayjson.feed.entry[i];
        let newDate = currentEntry.published_at.substr(0, 10).split('-');
        let dateMonth = monthNames[parseInt(newDate[1], 10)];
        let thisDate = `${newDate[2]} ${dateMonth} ${newDate[0]}`;
        let elementLinks = Array.from(inDDex.querySelectorAll('a'));
        let imageElements = Array.from(inDDex.querySelectorAll('a img'));
        let titleElement = document.querySelector('.feed-dday-title');
        let dateElement = document.querySelector('.feed-dday-date');
        let shareElement = document.querySelector('.feed-dday-condivisions');
        elementLinks.forEach(elementLink => {
          elementLink.setAttribute('href', currentEntry.url);
        });
        imageElements.forEach(imageElement => {
          imageElement.setAttribute(
            'src',
            `//images2.corriereobjects.it${currentEntry.src}`
          );
        });

        if (titleElement !== null) {
          titleElement.innerHTML = currentEntry.title;
        }

        if (dateElement !== null) {
          dateElement.innerHTML = thisDate;
        }

        if (shareElement !== null) {
          shareElement.innerHTML = currentEntry.comments_count;
        }

        i++;
      });
    });
  }

  fetchJson(url, callback = null) {
    return fetch(url)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        return response.json();
      })
      .then(data => {
        if (typeof callback === 'function') {
          callback(data);
        }
      })
      .catch(error => {
        throw new Error(`Failed fetching json. Reason: ${error}`);
      });
  }
}

module.exports = BoxDDayHP;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/boxes/BoxDDayHP.js